// src/pages/Home.jsx
import React from "react";
import { motion } from "framer-motion";
import Title from "../components/ui/Title";
import CoreValues from "../components/ui/CoreValues";

export default function Home() {
  return (
    <motion.div
      className="px-6 py-12 max-w-3xl mx-auto space-y-10 text-body bg-base"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <section className="space-y-4">
        <h1 className="text-4xl font-bold tracking-tight">
          Trăiește-ți Designul
        </h1>
        <p className="text-lg leading-relaxed">
          Un spațiu de vindecare tihnită, reflecție și revelații trăite. Human Design curat, viu și aplicat – fără junk, fără deturnări.
        </p>
      </section>

      <section>
               <CoreValues />
      </section>
    </motion.div>
  );
}
